module.exports = "<app-project-editor [project]=\"currentProject()\" (onEditProject)=\"editProject($event)\"></app-project-editor>\n"